export default __webpack_public_path__ + "static/37-b6b1acd9434c50967b750e947b433802.png";